/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Favorites Friends module
define('modules/Favorites/FavoritesFriends',[
    'jquery',
    'global/all',
    './FavoritesManager'
], function ($, Roc, FavoritesManager) {
    'use strict';

    var baseUrl;

    function deleteBtnEvt() {
        $(document).on('click', '.deleteFriendBtn', function () {
            var token = $(this).closest('li.friendItem').attr('data-token');
            FavoritesManager.deleteFriend(token);
        });
    }

    function reloadFriends() {
        $.get(baseUrl + '/ReloadFriends', function (data) {
            $('#friends-accordion').html($('#friends-accordion', data.html).html());
        });
    }

    function bindEvents() {
        deleteBtnEvt();
        Roc.EventManager.bind(Roc.Events.favorites.ADD_FRIEND, reloadFriends);
        Roc.EventManager.bind(Roc.Events.favorites.DELETE_FRIEND, reloadFriends);
    }

    function init(options) {
        baseUrl = options.baseUrl;
        bindEvents();
    };

    var FavoritesFriends = {
        init: init
    }

    Roc.Logger.debug('FavoritesFriends.js Loaded:', FavoritesFriends);

    return FavoritesFriends;
});

